if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }
    connectedCallback() {
      this.initSwiper();
    }
    initSwiper() {
      if (this.swiper) return;
      const container = this.querySelector('.swiper-container');
      if (!container) return;
      
      this.swiper = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        // NAVIGATION AND PAGINATION MODULES ACTIVATED
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
      });
    }
  });
}